import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContenedorBoton, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import styled from 'styled-components';
import { cargarCatalogosGenericoAsync } from '../../funciones_globales/catalogos';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import global_axios from '../../funciones_globales/interaccionapi';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { cargar_ChequesporCliente } from '../../actions/clientes/act_cli02';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { validarCampoString, validarJSON, validarFechaMomentEnFormatoString, validarPermisoAcceso } from '../../funciones_globales/utils';
import { formatearNumeroDecimal, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { getFechaProcesoPorModulo, getItemDatosSesion } from '../../funciones_globales/manejosesion';

const LabelCheques = styled.label`
  display: inline-block;
  font-size: 12px;
  padding-top: 15px;
  font-style: italic;
`;

const LabelChequeSel = styled.label`
  display: inline-block;
  font-size: 12px;  
  color: green;
  margin-left: 5px;
`;

class FormCli02 extends React.Component{
  
  constructor(props) {
    super(props);
    this.state = {
      operacion: 'M',
      cliente_sel: null,
      cheque_sel: null,
      nuevaFechaDepChq: null,
      cheques: [],
      columnsDefGridCheques: [
        { header: "",
          width: 30,
          checkboxSelection: true,
          suppressSorting: true,
          suppressMenu: true,
          suppressFilter: true,
          pinned: true
        },
        { header: "No.",
          field: "Secuencia",
          width: 35,
          type: "string",
          suppressFilter: true
        },
        {
          header: "Banco",
          field: "Banco",
          width: 155,
          type: "string"
        },
        { header: "Cuenta",
          field: "Cuenta",
          width: 100,
          type: "string"
        },
        { header: "Cheque",
          field: "Cheque",
          width: 70,
          type: "string"
        },
        { header: "Valor",
          field: "Valor",
          width: 80,
          type: "num_decimal"
        },
        { header: "Estado",
          field: "Estado",
          width: 60,
          type: "string",
          suppressFilter: true
        },
        { header: "Factura",
          field: "Factura",
          width: 80,
          type: "string"
        },
        { header: "Fecha",
          field: "FechaCheque",
          width: 80,
          type: "string"
        },
        { header: "F. Venc.",
          field: "FecVencimiento",
          width: 80,
          type: "string"
        },
        { header: "Saldo",
          field: "Saldo",
          width: 80,
          type: "num_decimal"
        },
        { header: "Caja",
          field: "Caja",
          width: 45,
          type: "string",
          suppressFilter: true
        },
        { header: "M. Caja",
          field: "Movimiento",
          width: 80,
          type: "string"
        },
        { header: "M. Banco",
          field: "MovBanco",
          width: 85,
          type: "string"
        }
      ]
    };
    this.gridChequesOptions = {
      enableColResize: true,
      enableCellChangeFlash: true,
      enableFilter: true,      
      enableSorting: true,
      onSelectionChanged:  ()=>{ this.onSelectionChequeChanged(); }
    };
    
    this.onGridChequesReady = this.onGridChequesReady.bind(this);
    this.limpiar = this.limpiar.bind(this);
    this.getOptions_Clientes = this.getOptions_Clientes.bind(this);
    this.modificarFechaCheque = this.modificarFechaCheque.bind(this);
    this.cargarChequesPorCliente = this.cargarChequesPorCliente.bind(this);
  }
 

  getOptions_Clientes(input, callback){
    if (input.toString().length >= 4 ){
      let query = "?tipo=catalogo&cadena_busq=" + input;
      cargarCatalogosGenericoAsync('/clientes', query, callback)
    }
  }

  onGridChequesReady(params) {
    this.apiGridCheques = params.api;
    this.columnApiGridCheques = params.columnApi;
  }
  
  componentDidMount(){
    this.props.generar_LogAuditoriaIngresoForm('0102');
    let fechaProceso = getFechaProcesoPorModulo('01');
    this.setState({nuevaFechaDepChq: moment(fechaProceso, 'DD/MM/YYYY')});    
  }

  componentWillUnmount(){
    this.props.generar_LogAuditoriaSalidaForm('0102');
  }

  cargarChequesPorCliente(){
    let cliente = this.state.cliente_sel;
    if (cliente===null || cliente === undefined){
      alert('Debe seleccionar el cliente del cual desea consultar los cheques.');
      return;
    }
    else{
      this.props.cargar_ChequesporCliente(cliente, 'P')
      .then(()=>{
        if (this.props.cheques.length>0){
          let cheques = [];
          this.props.cheques.forEach((cheque, i) => {
            cheques.push({
              Secuencia: (i+1),
              Banco: cheque.banco.Codigo + ' - ' + cheque.banco.Descripcion,
              Cuenta: cheque.Cuenta,
              Cheque: cheque.Cheque,
              Valor: cheque.Valor,
              Estado: cheque.Status,
              Factura: cheque.Factura,
              FechaCheque: cheque.FechaCheque,
              FecVencimiento: cheque.Vencimiento,
              Saldo: cheque.Saldo,
              Caja: cheque.Caja,
              Movimiento: cheque.Movimiento,
              MovBanco: cheque.MovBanco,              
            });
          });
          this.setState({cheques, cheque_sel: null});
        }
      });
    }
  }

  onSelectionChequeChanged(){

    let chequesSeleccionados = this.apiGridCheques.getSelectedRows();
        
    if (chequesSeleccionados.length===1){      
      this.setState({cheque_sel:
        { Banco: chequesSeleccionados[0].Banco,
          Cuenta: chequesSeleccionados[0].Cuenta,
          Cheque: chequesSeleccionados[0].Cheque,
          Valor: parseFloat(chequesSeleccionados[0].Valor || 0).toFixed(2),
          FechaCheque: chequesSeleccionados[0].FechaCheque,
          FecVencimiento: chequesSeleccionados[0].FecVencimiento
        }});
    }else{
      this.setState({cheque_sel: null});
    }
  }

  limpiar(){
    let fechaProceso = getFechaProcesoPorModulo('01');    
    this.setState({
      cliente_sel: null,
      cheques: [],
      cheque_sel: null,
      nuevaFechaDepChq: moment(fechaProceso, 'DD/MM/YYYY')
    });
  }

  modificarFechaCheque(){   
    let idCliente = this.state.cliente_sel;
    
    if (!validarCampoString(idCliente, 7)){
      alert('El cliente que ha especificado es inválido.');
      return;
    }

    if(!validarJSON(this.state.cheque_sel)){
      alert('No ha seleccionado el cheque al cual desea cambiar la fecha.');
      return;
    }
    
    let idBanco = this.state.cheque_sel.Banco.substr(0, 2);
    let nroCuenta = this.state.cheque_sel.Cuenta;
    let nroCheque = this.state.cheque_sel.Cheque;

    if (!validarCampoString(idBanco, 2)){
      alert('El banco que ha especificado es inválido.');
      return;
    }
    if (!validarCampoString(nroCuenta, 1, 20)){
      alert('El número de cuenta que ha especificado es inválido.');
      return;
    }
    if (!validarCampoString(nroCheque, 1, 10)){
      alert('El número de cheque que ha especificado es inválido.');
      return;
    }

    let validPermiso = validarPermisoAcceso(this.state.operacion, this.props.permiso);
    if (!validPermiso.esValido){
      alert(validPermiso.msg);
      return;
    }

    let nuevaFechaDepChq = formatearFechaMoment_a_String(this.state.nuevaFechaDepChq);
    if (!validarFechaMomentEnFormatoString(nuevaFechaDepChq)){      
      alert('La nueva Fecha de Depósito que ha especificado es inválida.');
      return;
    }

    let cambiarFecha = window.confirm('¿Está seguro de cambiar la Fecha de Depósito del cheque seleccionado?');
    if(!cambiarFecha){
      return;
    }

    this.props.cambiar_VisualizacionLoading(true);
    global_axios({
      method: 'PUT',
      url: '/clientes/' + idCliente + '/cheques/' + idBanco + '/' + nroCuenta + '/' + nroCheque,
      data: { TipoModif: 'CambioFecha',
              FechaCheque: nuevaFechaDepChq,
              Vencimiento: nuevaFechaDepChq,
              Usuario: getItemDatosSesion('usuario'),
              IdRegAudit: this.props.idRegAudit
            }
    })
    .then(()=>{
      this.props.cambiar_VisualizacionLoading(false);
      alert('Modificación procesada con éxito.');
    })
    .catch((error)=>{
      this.props.cambiar_VisualizacionLoading(false);
      alert(error.response?error.response.data.msg:error.message);
    });
  }

  render(){
    return(
      <ContenedorForm porc_ancho={80}>
        <HeaderForm>
          <TituloForm>Modificación de fecha de cheques</TituloForm>
        </HeaderForm>
        <CuerpoForm>
          <Row margen_arriba={10}>
            <ContainerCol className='col-sm-5'>
              <LabelForm>Cliente:</LabelForm>
              <ReactSelectAsync value={this.state.cliente_sel} func_loadOptions={this.getOptions_Clientes}
                func_OnFocus={this.limpiar}
                func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({cliente_sel: value===null?null:value.value })}}/>
            </ContainerCol>
            <ContainerCol className='col-sm-1'>
              <ContenedorBoton margen_arriba={20}>
                <Tooltip placement="right" overlay='Buscar cheques'>
                  <button type='button' className='btn btn-success btn-sm' onClick={this.cargarChequesPorCliente}><i className='fa fa-search'></i></button>
                </Tooltip>
              </ContenedorBoton>
            </ContainerCol>
          </Row>
          <Row>
            <ContainerCol className='col-sm-12'><LabelCheques>Cheques Pendientes de Depósito:</LabelCheques></ContainerCol>
          </Row>
          <Row>
            <ContainerCol className='col-sm-12'>
              <AgGridRender altura='320px' data={this.state.cheques} columnas={this.state.columnsDefGridCheques}
                gridOptions={this.gridChequesOptions} onGridReady={this.onGridChequesReady}/>
            </ContainerCol>
          </Row>
          <Row>
            <ContainerCol className='col-sm-6'>
              <LabelForm>Cheque seleccionado:</LabelForm>
              <LabelChequeSel>
                {(this.state.cheque_sel!=null?`No.: ${this.state.cheque_sel.Cheque} | Cta.: ${this.state.cheque_sel.Cuenta} | Bco.: ${this.state.cheque_sel.Banco} | Valor: ${formatearNumeroDecimal(this.state.cheque_sel.Valor)}`:'')}
              </LabelChequeSel>
            </ContainerCol>
            <ContainerCol className='col-sm-2'>
              <LabelForm>Fecha cheque:</LabelForm>
              <LabelChequeSel>
                {this.state.cheque_sel!=null?this.state.cheque_sel.FechaCheque:''}
              </LabelChequeSel>
            </ContainerCol>
            <ContainerCol className='col-sm-2'>
              <LabelForm>Fecha a depositar:</LabelForm>
              <LabelChequeSel>
                {this.state.cheque_sel!=null?this.state.cheque_sel.FecVencimiento:''}
              </LabelChequeSel>
            </ContainerCol>
            <ContainerCol className='col-sm-2'>
              <LabelForm>Nueva Fecha a Dep.:</LabelForm>
              <PickerFecha fechaSeleccionada={this.state.nuevaFechaDepChq}               
                func_onChange={(fecha)=>{this.setState({nuevaFechaDepChq: fecha})}}/>
            </ContainerCol>
          </Row>
          <Row margen_arriba={15}>
            <div className='col-sm-12'>
              <div className='btn-group pull-right'>
                <button type='button' className='btn btn-primary btn-sm' onClick={this.modificarFechaCheque}><i className='fa fa-floppy-o fa-lg'/> Cambiar Fecha</button>
                <button type='button' className='btn btn-sm' onClick={this.limpiar}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>
              </div>
            </div>
          </Row>
        </CuerpoForm>
      </ContenedorForm>
    );
  }
  
}

const mapStateToProps = state =>{
  return {  permiso: state.sesion.valoresSesionForm.Permiso,
            idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
            cheques: state.clientes.cheques
  };
};

const mapDispatchToProps = ((dispatch) => {  
  return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm, cargar_ChequesporCliente, cambiar_VisualizacionLoading }, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormCli02);